"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useConfig } from "@travel/shared/data-access";
import { ThemedLogo, } from "@travel/shared/theme/ui";
import PPNLogo from "@travel/shared/assets/icons/logos/ppn.svg";
import PPNColorLogo from "@travel/shared/assets/icons/logos/ppn-color.svg";
import styles from "./global-logo.module.css";
export function GlobalLogo(_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.innerClassName, innerClassName = _d === void 0 ? "" : _d, _e = _a.imgClassName, imgClassName = _e === void 0 ? "" : _e, poweredBy = _a.poweredBy, showProduct = _a.showProduct, _f = _a.productName, productName = _f === void 0 ? "hotels" : _f, _g = _a.alignProduct, alignProduct = _g === void 0 ? "center" : _g, _h = _a.alignPartner, alignPartner = _h === void 0 ? "center" : _h, _j = _a.horizontal, horizontal = _j === void 0 ? true : _j, _k = _a.size, size = _k === void 0 ? "md" : _k, theme = _a.theme, darkTheme = _a.darkTheme, allowDarkMode = _a.allowDarkMode, rest = __rest(_a, ["className", "innerClassName", "imgClassName", "poweredBy", "showProduct", "productName", "alignProduct", "alignPartner", "horizontal", "size", "theme", "darkTheme", "allowDarkMode"]);
    var config = useConfig();
    var companyName = config.companyName;
    var hasProduct = !!config.assets.logoHasProduct;
    var hasPoweredBy = !!config.assets.logoHasPoweredBy;
    var logo = config.assets.logo;
    var logoLight = config.assets.logoLight || logo;
    var logoDark = config.assets.logoDark || logo;
    var mode = theme === "light" || theme === "dark" ? theme : undefined;
    var darkMode = darkTheme === "light" || darkTheme === "dark" ? darkTheme : mode;
    return (_jsxs("div", { className: classNames(styles["container"], className, (_b = {},
            _b[styles[size]] = size !== "md",
            _b[styles["horizontal"]] = horizontal,
            _b[styles["has-product"]] = !!showProduct,
            _b[styles["has-partner"]] = !!poweredBy,
            _b[styles["align-partner-".concat(alignPartner)]] = alignPartner && alignPartner !== "center",
            _b[styles["align-product-".concat(alignProduct)]] = alignProduct && alignProduct !== "center",
            _b)), children: [_jsxs("div", { className: classNames(styles["logo"], innerClassName), children: [_jsx(ThemedLogo, __assign({}, rest, { imgClassName: classNames(styles["img"], imgClassName), mode: mode, darkMode: darkMode, logo: logo, light: logoLight, dark: logoDark, alt: "".concat(companyName ? "".concat(companyName, " ") : "", "Logo") })), showProduct && hasProduct && (_jsx("div", { className: styles["product"], children: productName.toLowerCase() }))] }), poweredBy && _jsx(GlobalPoweredBy, { mode: mode, darkMode: darkMode })] }));
}
export function GlobalPoweredBy(_a) {
    var _b;
    var className = _a.className, _c = _a.mode, mode = _c === void 0 ? "color" : _c, _d = _a.darkMode, darkMode = _d === void 0 ? "light" : _d;
    return (_jsxs("div", { className: classNames(styles["powered"], className, (_b = {},
            _b[styles["mode__".concat(mode)]] = !!mode && mode !== "color",
            _b[styles["dark-mode__".concat(darkMode)]] = !!darkMode && darkMode !== "light",
            _b)), children: [_jsx("div", { children: "Powered by" }), _jsxs("div", { className: styles["partner"], children: [_jsx(PPNLogo, { className: classNames(styles["icon"]) }), _jsx(PPNColorLogo, { className: classNames(styles["icon"], styles["color"]) })] })] }));
}
